import React from "react"

const TagItem = ({ children, className, isGrey, ...rest }) => (
    <div className={calculateClassName(className, isGrey)} {...rest}>
        {children}
    </div>
)

export default TagItem

function calculateClassName(className, isGrey) {
    const classList = ["tag-item"]
    if (isGrey) classList.push("grey")
    if (className) classList.push(className)
    return classList.join(" ")
}
